import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isCardTokenizationUponOrderSelected = createSelector(
    creditCardsState,
    (creditCards) => creditCards.activeCardId === OLO.Enums.PAYMENT_VENDOR_SERVICE.CARD_TOKENIZATION_UPON_ORDER,
);
